import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

import { CollaborationRow } from './interfaces';

export const assistantsColumns: TableColumns<CollaborationRow> = [
  {
    title: 'lender.brokers.labels.name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'lender.brokers.labels.collaboration',
    key: 'collaborationType',
  },
  {
    title: 'lender.brokers.labels.role',
    dataIndex: 'roles',
    key: 'roles',
    options: {
      format: { type: 'multiValueList' },
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 80, fixed: 'right' },
];
